(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabsComponents = document.querySelectorAll('.tabs-container');
    tabsComponents.forEach(function (component) {
      const tabsLinks = component.querySelectorAll('.tabs-link');

      tabsLinks.forEach(function (link) {
        link.addEventListener('click', function () {
          const targetTab = this.getAttribute('data-tab');
          tabsLinks.forEach((item) => {
            item.classList.remove('active');
          });
          link.classList.add('active');
          const tabContents = component.querySelectorAll('.tab-content');
          tabContents.forEach(function (content) {
            content.classList.remove('active');
          });

          const activeTab = component.querySelector(`#${targetTab}`);
          if (activeTab) {
            activeTab.classList.add('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navimow-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const subscribeForms = document.querySelectorAll(
      '.navimow-banner-subscribe-form',
    );
    const requestJson = function (url, options = {}) {
      const baseUrl = window.baseUrl;
      return fetch(baseUrl + url, {
        headers: {
          'wb-api-key': 'd1befa03c79ca0b84ecc488dea96bc68',
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        ...options,
      }).then((res) => res.json());
    };
    subscribeForms.forEach((form) => {
      form.action = '';
      form.addEventListener('submit', (e) => {
        form.classList.add('loading');
        const submitBtn = form.querySelector('button[type="submit"]');
        submitBtn.disabled = true;

        e.preventDefault();
        const formData = new FormData(form);

        const site = window.site;

        window
          .getRecaptchaToken()
          .then((token) => {
            return requestJson(
              `/newOfficialWebsite/customer/addCustomerInfo?site=${site}`,
              {
                method: 'POST',
                body: JSON.stringify({
                  email: formData.get('contact[email]'),
                  tags: `${formData.get('contact[tags]')}`,
                  recaptchaToken: token,
                  emailMarketingConsent: {
                    marketingState: 'SUBSCRIBED',
                    marketingOptInLevel: 'SINGLE_OPT_IN',
                  },
                }),
              },
            );
          })

          .then((data) => {
            if (data.code === 200) {
              form.classList.add('success');
            } else {
              form.classList.add('error');
            }
            setTimeout(() => {
              form.classList.remove('success');
              form.classList.remove('error');
              form.reset();
            }, 3500);
          })
          .catch((error) => {
            form.classList.add('error');
          })
          .finally(() => {
            form.classList.remove('loading');
            submitBtn.disabled = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navimow-carousel-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function isHidden(element) {
      if (!element || element.nodeType !== 1) {
        return true;
      }
      return element.offsetWidth === 0 && element.offsetHeight === 0;
    }

    const videoBlocks = document.querySelectorAll(
      '.navimow-carousel-card .video-js',
    );
    const youtubeBlocks = document.querySelectorAll(
      '.navimow-carousel-card youtube-video',
    );

    const playerArray = [];

    videoBlocks.forEach((video, idx) => {
      const player = videojs(video, {});
      playerArray.push(player);
    });

    playerArray.forEach((player) => {
      player.on('fullscreenchange', () => {
        player.controls(player.isFullscreen());
        if (
          !player.isFullscreen() &&
          window.matchMedia('(max-width: 768px)').matches &&
          !player.paused()
        ) {
          setTimeout(() => {
            player.play();
          }, 500);
        }
      });
      const el = player.el();

      if (isHidden(el)) return;

      const parent = el.parentElement;
      const videoPlayPauseBtn = parent.querySelector('.video-play-pause-btn');
      const videoFullscreenBtn = parent.querySelector('.video-fullscreen-btn');

      player.on('play', () => {
        if (videoPlayPauseBtn) {
          videoPlayPauseBtn.classList.add('active');
        }
        playerArray.forEach((item) => {
          if (item !== player) {
            item.pause();
          }
        });
        youtubeBlocks.forEach((item) => {
          item.pause();
        });
      });
      player.on('pause', () => {
        if (videoPlayPauseBtn) {
          videoPlayPauseBtn.classList.remove('active');
        }
      });

      if (videoFullscreenBtn) {
        videoFullscreenBtn.addEventListener('click', () => {
          const videoUrl = window.matchMedia('(max-width: 768px)').matches
            ? videoFullscreenBtn.getAttribute('data-video-url-mb')
            : videoFullscreenBtn.getAttribute('data-video-url');
          if (videoUrl) {
            // Create a fullscreen HTML5 video element and play the URL
            const fullscreenVideo = document.createElement('video');
            fullscreenVideo.src = videoUrl;
            fullscreenVideo.controls = true;
            fullscreenVideo.autoplay = true;
            fullscreenVideo.style.position = 'fixed';
            fullscreenVideo.style.top = 0;
            fullscreenVideo.style.left = 0;
            fullscreenVideo.style.width = '100vw';
            fullscreenVideo.style.height = '100vh';
            fullscreenVideo.style.zIndex = 9999;
            fullscreenVideo.style.backgroundColor = '#000';
            fullscreenVideo.setAttribute('playsinline', '');
            fullscreenVideo.setAttribute('webkit-playsinline', '');

            document.body.appendChild(fullscreenVideo);

            // Fullscreen API
            const requestFullScreen =
              fullscreenVideo.requestFullscreen ||
              fullscreenVideo.webkitRequestFullscreen ||
              fullscreenVideo.mozRequestFullScreen ||
              fullscreenVideo.msRequestFullscreen;

            if (requestFullScreen) {
              requestFullScreen.call(fullscreenVideo);
            }

            // Exit and cleanup when video or fullscreen ends
            const cleanup = () => {
              fullscreenVideo.pause();
              fullscreenVideo.parentNode &&
                fullscreenVideo.parentNode.removeChild(fullscreenVideo);
            };

            fullscreenVideo.addEventListener('fullscreenchange', function () {
              if (
                !document.fullscreenElement &&
                !document.webkitFullscreenElement
              ) {
                cleanup();
              }
            });
            fullscreenVideo.addEventListener(
              'webkitfullscreenchange',
              function () {
                if (
                  !document.fullscreenElement &&
                  !document.webkitFullscreenElement
                ) {
                  cleanup();
                }
              },
            );
            fullscreenVideo.addEventListener('ended', cleanup);
            fullscreenVideo.addEventListener('pause', function () {
              // Also cleanup on pause (optional, remove if not wanted)
              // cleanup();
            });
          }
        });
      }
      if (videoPlayPauseBtn) {
        videoPlayPauseBtn.addEventListener('click', () => {
          if (player.paused()) {
            player.play();
          } else {
            player.pause();
          }
        });
      }
    });

    youtubeBlocks.forEach((youtube, idx) => {
      const videoPlayPauseBtn = youtube.parentElement.querySelector(
        '.video-play-pause-btn',
      );
      if (videoPlayPauseBtn) {
        videoPlayPauseBtn.addEventListener('click', () => {
          youtube.play();
        });
      }

      youtube.addEventListener('video:play', () => {
        youtubeBlocks.forEach((item) => {
          if (item !== youtube) {
            item.pause();
          }
        });
        playerArray.forEach((item) => {
          item.pause();
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navimow-prize-wheel"] && !Shopify.designMode) return;
  try {
    
  if (
    window.customElements &&
    !window.customElements.get('navimow-prize-wheel-widget')
  ) {
    class NavimowPrizeWheelWidget extends HTMLElement {
      constructor() {
        super();
        this.shadowRootRef =
          this.shadowRoot ||
          this.attachShadow({ mode: 'open', delegatesFocus: true });
        this.currentRotation = 0;
        this.isSpinning = false;
        this.isInitialized = false;
        this.prizes = [];
        this.cssWidth = 0;
        this.cssHeight = 0;
        this.pixelRatio = 1;
        this.ctx = null;
        this.backgroundImage = null;
        this.imagePromises = new Map();
        this.loadedImages = new Map();
        this.resizeObserver = null;
        this.staticWheelCanvas = document.createElement('canvas');
        this.staticWheelCtx = this.staticWheelCanvas.getContext('2d');
        this.handlePrizeButtonClick = this.handlePrizeButtonClick.bind(this);
        this.handleWindowResize = this.handleWindowResize.bind(this);
      }

      connectedCallback() {
        if (!this.shadowRootRef.hasChildNodes()) {
          this.shadowRootRef.innerHTML =
            '<style>:host{display:block;isolation:isolate;contain:paint;}::slotted(*){box-sizing:border-box;}</style><slot></slot>';
        }

        if (this.isInitialized) return;

        this.sectionEl = this.closest('.navimow-prize-wheel');
        this.stageEl = this.querySelector('.prize-wheel-stage');
        this.canvasEl = this.querySelector('.prize-wheel-canvas');
        this.prizeButton = this.querySelector('.prize-button');

        if (!this.sectionEl || !this.stageEl || !this.canvasEl) {
          return;
        }

        this.ctx = this.canvasEl.getContext('2d', {
          alpha: true,
        });
        if (!this.ctx) return;

        if (this.prizeButton) {
          this.prizeButton.addEventListener(
            'click',
            this.handlePrizeButtonClick,
          );
        }
        if (window.ResizeObserver) {
          this.resizeObserver = new window.ResizeObserver(
            this.handleWindowResize,
          );
          this.resizeObserver.observe(this.stageEl);
        } else {
          window.addEventListener('resize', this.handleWindowResize);
        }

        this.isInitialized = true;
        this.updateCanvasSize();
        this.loadBackgroundImage();
      }

      disconnectedCallback() {
        if (this.prizeButton) {
          this.prizeButton.removeEventListener(
            'click',
            this.handlePrizeButtonClick,
          );
        }
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver = null;
        } else {
          window.removeEventListener('resize', this.handleWindowResize);
        }
        this.isInitialized = false;
      }

      renderPrizeItems(prizes) {
        this.prizes = Array.isArray(prizes) ? prizes : [];

        this.sectionEl.navimowPrizeWheel =
          this.sectionEl.navimowPrizeWheel || {};
        this.sectionEl.navimowPrizeWheel.prizes = this.prizes;
        if (
          typeof this.sectionEl.navimowPrizeWheel.syncPrizeButtonState ===
          'function'
        ) {
          this.sectionEl.navimowPrizeWheel.syncPrizeButtonState();
        }

        this.prizes.forEach(
          function (prize) {
            if (prize && prize.imageUrl) {
              this.loadImage(prize.imageUrl).then(
                function () {
                  this.rebuildStaticWheel();
                  this.drawWheel(this.currentRotation);
                }.bind(this),
              );
            }
          }.bind(this),
        );

        this.rebuildStaticWheel();
        this.drawWheel(this.currentRotation);
      }

      getPrizeCount() {
        return this.prizes.length || 4;
      }

      handleWindowResize() {
        this.updateCanvasSize();
      }

      hermite(p, p0, p1, v0, v1) {
        var p2 = p * p;
        var p3 = p2 * p;
        return (
          (2 * p3 - 3 * p2 + 1) * p0 +
          (p3 - 2 * p2 + p) * v0 +
          (-2 * p3 + 3 * p2) * p1 +
          (p3 - p2) * v1
        );
      }

      loadImage(src) {
        if (!src) return Promise.resolve(null);
        if (this.imagePromises.has(src)) {
          return this.imagePromises.get(src);
        }

        var promise = new Promise(
          function (resolve) {
            var isResolved = false;
            var image = new Image();
            image.decoding = 'async';
            image.crossOrigin = 'anonymous';

            var finalize = function (loadedImage) {
              if (isResolved) return;
              isResolved = true;
              this.loadedImages.set(src, loadedImage);
              resolve(loadedImage);
            }.bind(this);

            image.onload = function () {
              finalize(image);
            };
            image.onerror = function () {
              finalize(null);
            };
            image.src = src;

            if (image.complete && image.naturalWidth > 0) {
              finalize(image);
            }
          }.bind(this),
        );

        this.imagePromises.set(src, promise);
        return promise;
      }

      loadBackgroundImage() {
        var backgroundUrl = this.dataset.wheelBackground || '';
        if (!backgroundUrl) {
          this.backgroundImage = null;
          this.drawWheel(this.currentRotation);
          return Promise.resolve(null);
        }

        return this.loadImage(backgroundUrl).then(
          function (image) {
            this.backgroundImage = image;
            this.rebuildStaticWheel();
            this.drawWheel(this.currentRotation);
            return image;
          }.bind(this),
        );
      }

      updateCanvasSize() {
        if (
          !this.stageEl ||
          !this.canvasEl ||
          !this.ctx ||
          !this.staticWheelCanvas ||
          !this.staticWheelCtx
        ) {
          return;
        }

        var rect = this.stageEl.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        var cssWidth = Math.round(rect.width);
        var cssHeight = Math.round(rect.height);
        var pixelRatio = Math.max(1, Math.min(window.devicePixelRatio || 1, 3));
        var bitmapWidth = Math.max(1, Math.round(cssWidth * pixelRatio));
        var bitmapHeight = Math.max(1, Math.round(cssHeight * pixelRatio));

        if (
          this.canvasEl.width !== bitmapWidth ||
          this.canvasEl.height !== bitmapHeight
        ) {
          this.canvasEl.width = bitmapWidth;
          this.canvasEl.height = bitmapHeight;
        }
        if (
          this.staticWheelCanvas.width !== bitmapWidth ||
          this.staticWheelCanvas.height !== bitmapHeight
        ) {
          this.staticWheelCanvas.width = bitmapWidth;
          this.staticWheelCanvas.height = bitmapHeight;
        }

        this.canvasEl.style.width = cssWidth + 'px';
        this.canvasEl.style.height = cssHeight + 'px';
        this.cssWidth = cssWidth;
        this.cssHeight = cssHeight;
        this.pixelRatio = pixelRatio;

        this.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        this.ctx.imageSmoothingEnabled = true;
        if ('imageSmoothingQuality' in this.ctx) {
          this.ctx.imageSmoothingQuality = 'high';
        }

        this.staticWheelCtx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        this.staticWheelCtx.imageSmoothingEnabled = true;
        if ('imageSmoothingQuality' in this.staticWheelCtx) {
          this.staticWheelCtx.imageSmoothingQuality = 'high';
        }

        this.rebuildStaticWheel();
        this.drawWheel(this.currentRotation);
      }

      rebuildStaticWheel() {
        if (
          !this.staticWheelCtx ||
          !this.staticWheelCanvas ||
          !this.cssWidth ||
          !this.cssHeight
        ) {
          return;
        }

        var ctx = this.staticWheelCtx;
        var diameter = Math.min(this.cssWidth, this.cssHeight);
        var radius = diameter / 2;
        var centerX = this.cssWidth / 2;
        var centerY = this.cssHeight / 2;

        ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        ctx.clearRect(0, 0, this.cssWidth, this.cssHeight);

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        this.drawWheelBase(ctx, radius);
        this.drawWheelPrizes(ctx, radius, diameter);
        ctx.restore();

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.beginPath();
        ctx.arc(0, 0, radius - 0.75, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.06)';
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.restore();
      }

      drawWheel(angle) {
        if (
          !this.ctx ||
          !this.cssWidth ||
          !this.cssHeight ||
          !this.staticWheelCanvas
        ) {
          return;
        }

        var ctx = this.ctx;
        var diameter = Math.min(this.cssWidth, this.cssHeight);
        var radius = diameter / 2;
        var centerX = this.cssWidth / 2;
        var centerY = this.cssHeight / 2;
        var normalizedAngle = ((angle % 360) + 360) % 360;

        ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        ctx.clearRect(0, 0, this.cssWidth, this.cssHeight);

        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        ctx.rotate((normalizedAngle * Math.PI) / 180);
        ctx.drawImage(
          this.staticWheelCanvas,
          -centerX,
          -centerY,
          this.cssWidth,
          this.cssHeight,
        );
        ctx.restore();
      }

      drawWheelBase(ctx, radius) {
        if (this.backgroundImage && this.backgroundImage.naturalWidth > 0) {
          var coverScale = Math.max(
            (radius * 2) / this.backgroundImage.naturalWidth,
            (radius * 2) / this.backgroundImage.naturalHeight,
          );
          var drawWidth = this.backgroundImage.naturalWidth * coverScale;
          var drawHeight = this.backgroundImage.naturalHeight * coverScale;

          ctx.drawImage(
            this.backgroundImage,
            -drawWidth / 2,
            -drawHeight / 2,
            drawWidth,
            drawHeight,
          );
        } else {
          ctx.fillStyle = '#E5E7EB';
          ctx.fillRect(-radius, -radius, radius * 2, radius * 2);
        }
      }

      drawWheelPrizes(ctx, radius, diameter) {
        if (!this.prizes.length) return;

        var segmentAngle = (Math.PI * 2) / this.prizes.length;
        this.prizes.forEach(
          function (prize, index) {
            ctx.save();
            ctx.rotate(segmentAngle * index);
            this.drawPrizeAtTop(ctx, prize, radius, diameter);
            ctx.restore();
          }.bind(this),
        );
      }

      drawPrizeAtTop(ctx, prize, radius, diameter) {
        var image =
          prize && prize.imageUrl
            ? this.loadedImages.get(prize.imageUrl)
            : null;
        var title =
          prize && prize.externalTitle ? String(prize.externalTitle) : '';
        var imageSize = Math.min(diameter * 0.16, 74);
        imageSize = Math.max(imageSize, 44);
        var itemWidth = diameter * 0.3;
        var radialOffset = radius * 0.5;
        var fontSize = Math.max(11, Math.round(diameter * 0.026));
        var lineHeight = fontSize * 1.28;
        var lines = this.getWrappedLines(title, itemWidth, fontSize, 2);
        var hasImage = Boolean(image && image.naturalWidth > 0);
        var textHeight = lines.length ? lines.length * lineHeight : 0;
        var gap = hasImage && lines.length ? Math.max(1, diameter * 0.004) : 0;
        var contentHeight = textHeight + (hasImage ? imageSize : 0) + gap;
        var startY = -contentHeight / 2;

        ctx.save();
        ctx.translate(0, -radialOffset);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        ctx.fillStyle = '#161616';
        ctx.font =
          '600 ' +
          fontSize +
          'px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        lines.forEach(function (line, lineIndex) {
          ctx.fillText(line, 0, startY + lineIndex * lineHeight);
        });

        if (hasImage) {
          var imageTop = startY + textHeight + gap;
          this.drawContainedImage(
            ctx,
            image,
            -imageSize / 2,
            imageTop,
            imageSize,
            imageSize,
          );
        }

        ctx.restore();
      }

      getWrappedLines(text, maxWidth, fontSize, maxLines) {
        if (!text) return [];
        if (!this.ctx) return [text];

        var ctx = this.ctx;
        ctx.save();
        ctx.font =
          '600 ' +
          fontSize +
          'px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

        var tokens = text.includes(' ')
          ? text.split(/\s+/).filter(Boolean)
          : text.split('');
        if (!tokens.length) {
          ctx.restore();
          return [];
        }

        var lines = [];
        var currentLine = '';

        tokens.forEach(function (token) {
          var candidate = currentLine
            ? text.includes(' ')
              ? currentLine + ' ' + token
              : currentLine + token
            : token;
          if (ctx.measureText(candidate).width <= maxWidth || !currentLine) {
            currentLine = candidate;
            return;
          }

          lines.push(currentLine);
          currentLine = token;
        });

        if (currentLine) {
          lines.push(currentLine);
        }

        if (lines.length > maxLines) {
          lines = lines.slice(0, maxLines);
          var lastLine = lines[maxLines - 1];
          while (
            lastLine.length > 1 &&
            ctx.measureText(lastLine + '…').width > maxWidth
          ) {
            lastLine = lastLine.slice(0, -1);
          }
          lines[maxLines - 1] = lastLine + '…';
        }

        ctx.restore();
        return lines;
      }

      drawContainedImage(ctx, image, x, y, width, height) {
        var scale = Math.min(
          width / image.naturalWidth,
          height / image.naturalHeight,
        );
        var drawWidth = image.naturalWidth * scale;
        var drawHeight = image.naturalHeight * scale;
        var offsetX = x + (width - drawWidth) / 2;
        var offsetY = y + (height - drawHeight) / 2;

        ctx.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);
      }

      getPrizeIndexByRecord(lotteryRecord) {
        var state = this.sectionEl.navimowPrizeWheel || {};
        var prizes = Array.isArray(state.prizes) ? state.prizes : [];
        if (!prizes.length || !lotteryRecord) return -1;

        var targetPrizeId =
          lotteryRecord.id != null ? String(lotteryRecord.id) : '';
        if (!targetPrizeId) return -1;

        return prizes.findIndex(function (prize) {
          return (
            prize && prize.id != null && String(prize.id) === targetPrizeId
          );
        });
      }

      requestDrawResult() {
        var state = this.sectionEl.navimowPrizeWheel || {};
        var latestEmail = state.latestEmail;
        if (typeof state.clearErrors === 'function') {
          state.clearErrors();
        }

        const site = window.site || window.getSite();
        const baseUrl = window.baseUrl;
        let deviceId = '';
        return window
          .getDeviceFingerprint()
          .then((fp) => {
            deviceId = fp;
            return window.getRecaptchaToken();
          })
          .then((token) => {
            return window.requestJson('/newOfficialWebsite/lottery/draw-v2', {
              method: 'POST',
              body: JSON.stringify({
                email: latestEmail,
                recaptchaToken: token,
                activityId: state.activityId,
                pageUrl: window.location.href,
                deviceId,
                tags: state.getDrawTags(),
              }),
            });
          })
          .then(
            function (res) {
              if (!res || res.code !== 200) {
                showError('api', res?.message || 'Server error. Please try again later.');
                return;
              }

              var drawData = res.data || {};
              var prizeIndex = this.getPrizeIndexByRecord(drawData);

              if (prizeIndex < 0) {
                throw new Error('Prize record not found in prize list');
              }

              if (typeof state.setLotteryCount === 'function') {
                var nextLotteryCount = Number(drawData.lotteryCount);
                if (!Number.isFinite(nextLotteryCount)) {
                  nextLotteryCount = Math.max(
                    Number(state.lotteryCount || 0) - 1,
                    0,
                  );
                }
                state.setLotteryCount(nextLotteryCount);
              }
              state.latestLotteryRecord = drawData;
              if (Array.isArray(state.resultList)) {
                if (!drawData.time) {
                  var now = new Date();
                  var year = now.getFullYear();
                  var month = String(now.getMonth() + 1).padStart(2, '0');
                  var day = String(now.getDate()).padStart(2, '0');
                  var hours = String(now.getHours()).padStart(2, '0');
                  var minutes = String(now.getMinutes()).padStart(2, '0');
                  drawData.time =
                    year +
                    '-' +
                    month +
                    '-' +
                    day +
                    ' ' +
                    hours +
                    ':' +
                    minutes;
                }
                state.resultList.unshift(drawData);
                state.resultList = state.resultList.slice(0, 10);
              }

              return prizeIndex;
            }.bind(this),
          )
          .catch(function (error) {
            if (typeof state.showError === 'function') {
              state.showError('api');
            }
            window.alert(
              (error && error.message) ||
                'Server error. Please try again later.',
            );
            throw error;
          });
      }

      startSpin(fetchResult, options) {
        if (this.isSpinning) return null;
        this.isSpinning = true;

        var opts = Object.assign(
          {},
          {
            accelTime: 1200,
            decelTime: 2800,
            decelRounds: 3,
            accelSharpness: 1.5,
            decelSharpness: 1.5,
            cruiseDegsPerMs: 2,
            pointerAngleOffset: 0,
            settleAmplitude: 6,
            settleDuration: 600,
            settleFreq: 3,
          },
          options || {},
        );
        var accelTime = opts.accelTime;
        var decelTime = opts.decelTime;
        var decelRounds = opts.decelRounds;
        var accelSharpness = opts.accelSharpness;
        var cruiseDegsPerMs = opts.cruiseDegsPerMs;
        var pointerAngleOffset = opts.pointerAngleOffset;
        var settleAmplitude = opts.settleAmplitude;
        var settleDuration = opts.settleDuration;
        var settleFreq = opts.settleFreq;

        var accelDistance = 0.5 * cruiseDegsPerMs * accelTime;
        var accelStartAngle = this.currentRotation;

        var phase = 'accel';
        var startTime = null;

        var cruiseStartTime = null;
        var cruiseStartAngle = 0;

        var decelStartTime = null;
        var decelStartAngle = 0;
        var decelTargetAngle = 0;
        var decelDelta = 0;

        var settleStartTime = null;
        var settleBaseAngle = 0;

        var targetIndex = null;
        var resolvePromise = null;
        var rejectPromise = null;
        var promise = new Promise(function (resolve, reject) {
          resolvePromise = resolve;
          rejectPromise = reject;
        });

        var resultReady = false;
        var resultIndex = null;
        var fetchStarted = false;

        var beginFetch = function () {
          if (fetchStarted) return;
          fetchStarted = true;

          fetchResult()
            .then(function (idx) {
              resultIndex = idx;
              resultReady = true;
            })
            .catch(
              function (error) {
                phase = 'done';
                this.isSpinning = false;
                if (typeof rejectPromise === 'function') {
                  rejectPromise(error);
                }
              }.bind(this),
            );
        }.bind(this);

        var beginDecel = function (timestamp) {
          phase = 'decel';
          targetIndex = resultIndex;
          decelStartTime = timestamp;
          decelStartAngle = this.currentRotation;

          var naturalDistance = 0.5 * cruiseDegsPerMs * decelTime;

          var segmentAngle = 360 / this.getPrizeCount();
          var prizeAngle =
            (pointerAngleOffset - targetIndex * segmentAngle + 360) % 360;

          var rawTarget = this.currentRotation + naturalDistance;
          var remainder = rawTarget % 360;
          var forward = (prizeAngle - remainder + 360) % 360;
          decelDelta = naturalDistance + decelRounds * 360 + forward;
          if (decelDelta < naturalDistance * 0.8) {
            decelDelta += 360;
          }
          decelTargetAngle = decelStartAngle + decelDelta;
        }.bind(this);

        var animate = function (timestamp) {
          if (!startTime) startTime = timestamp;

          if (phase === 'accel') {
            var t = Math.min((timestamp - startTime) / accelTime, 1);
            var angle =
              accelStartAngle +
              this.hermite(
                t,
                0,
                accelDistance,
                0,
                cruiseDegsPerMs * accelTime * (1 / accelSharpness),
              );
            this.drawWheel(angle);
            this.currentRotation = angle;

            if (t >= 1) {
              phase = 'cruise';
              cruiseStartTime = timestamp;
              cruiseStartAngle = accelStartAngle + accelDistance;
              this.currentRotation = cruiseStartAngle;
              beginFetch();
            }
            requestAnimationFrame(animate);
          } else if (phase === 'cruise') {
            var cruiseElapsed = timestamp - cruiseStartTime;
            var angle = cruiseStartAngle + cruiseDegsPerMs * cruiseElapsed;
            this.drawWheel(angle);
            this.currentRotation = angle;

            if (resultReady) {
              beginDecel(timestamp);
            }
            requestAnimationFrame(animate);
          } else if (phase === 'decel') {
            var dt = Math.min((timestamp - decelStartTime) / decelTime, 1);
            var pos = this.hermite(
              dt,
              0,
              decelDelta,
              cruiseDegsPerMs * decelTime,
              0,
            );
            var angle = decelStartAngle + pos;
            this.drawWheel(angle);
            this.currentRotation = angle;

            if (dt >= 1) {
              phase = 'settle';
              settleStartTime = timestamp;
              settleBaseAngle = decelTargetAngle;
              this.currentRotation = settleBaseAngle;
            }
            requestAnimationFrame(animate);
          } else if (phase === 'settle') {
            var st = (timestamp - settleStartTime) / settleDuration;
            if (st >= 1) {
              this.drawWheel(settleBaseAngle);
              this.currentRotation = settleBaseAngle;
              this.isSpinning = false;
              phase = 'done';
              resolvePromise(targetIndex);
              return;
            }
            var decay = Math.exp(-5 * st);
            var wobble =
              settleAmplitude * decay * Math.sin(st * settleFreq * Math.PI * 2);
            this.drawWheel(settleBaseAngle + wobble);
            requestAnimationFrame(animate);
          }
        }.bind(this);

        requestAnimationFrame(animate);

        return { promise: promise };
      }

      handlePrizeButtonClick() {
        var state = this.sectionEl.navimowPrizeWheel || {};
        if (Number(state.lotteryCount || 0) <= 0 || !state.latestEmail) return;
        if (!Array.isArray(state.prizes) || !state.prizes.length) return;

        var ctrl = this.startSpin(this.requestDrawResult.bind(this));
        if (!ctrl) return;

        ctrl.promise
          .then(function (index) {
            console.log('Landed on prize index:', index);
            if (typeof state.openResultModal === 'function') {
              state.openResultModal(state.latestLotteryRecord);
              state.getRecord(state.latestEmail);
            }
          })
          .catch(function (error) {
            console.error('Prize draw failed:', error);
          });
      }
    }

    customElements.define(
      'navimow-prize-wheel-widget',
      NavimowPrizeWheelWidget,
    );
  }

  } catch(e) { console.error(e); }
})();
})();
